import { getItemWebStorage } from "src/features/webStorageSaver";
import { navigateTo } from "../../../../../navigationService/navigationServiceFunctions";

export function handleFeatureDefault(feature: any) {
    const { id: layerId, properties } = feature ?? {}
    const [layerName] = layerId.split('.');
    const { InfoObjectID, LinkedObjectID } = properties ?? {}
    const objectId = InfoObjectID ?? LinkedObjectID
    const normalizedLayerName = getNormalizedLayerName(layerName)
    const objectsTypes = getItemWebStorage("objectTypes");
    let objectType = objectsTypes.find(objType => objType.mapLayer === normalizedLayerName)?.name
    if (!objectType) objectType = getObjectTypeFromLayerName(layerName);
    navigateTo(`/app/table/${objectType}/${objectId}`)
}

export function getNormalizedLayerName(layerName: string): string {
    const exact = { MXRoadSign: 'MARoadSign' };
    if (exact[layerName]) return exact[layerName];
    if (layerName.startsWith('MD')) {
        layerName = layerName.replace(/[\d-]/g, '')
    }
    return 'MA' + layerName.slice(2)
        .replace(/_.*/, '')
        .replace('ForFilters', '')
        .replace('SQL', '');
}

export function getObjectTypeFromLayerName(layerName: string): string {
    if (layerName.startsWith('MD')) {
        layerName = layerName.replace(/[\d-]/g, '')
    }
    return layerName
        .slice(2)
        .replace(/_.*/, '')
        .replace(/[\d-]/g, '')
        .replace('ForFilters', '')
        .replace('SQL', '') + 's';
}